import { useEffect, useRef } from "react";
import * as ChannelService from "@channel.io/channel-web-sdk-loader";

export interface ChannelUserInfo {
  id: string;
  name: string;
  [key: string]: any;
}

export const useChannelTalk = (
  userInfo?: ChannelUserInfo | null,
  enabled: boolean = true
) => {
  const isInitialized = useRef(false);

  useEffect(() => {
    // enabled가 true이고 아직 초기화 안 되었을 때만 실행
    if (enabled && !isInitialized.current) {
      // 최초 1회만 로드
      ChannelService.loadScript();

      const bootOption: any = {
        pluginKey: "b42e529e-1eb4-413c-a55e-f2d671c76585",
      };

      // 유저 정보가 있으면 추가
      if (userInfo) {
        bootOption.memberId = userInfo.id;
        bootOption.profile = {
          name: userInfo.name,
        };
      }

      // 채널톡 실행 (최초 1회만)
      ChannelService.boot(bootOption);
      isInitialized.current = true;
    }

    return () => {
      // cleanup 시에만 shutdown
      if (isInitialized.current) {
        ChannelService.shutdown();
        isInitialized.current = false;
      }
    };
  }, [userInfo?.id, userInfo?.name, enabled]);
};
